// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import t from 'tcomb';

const Agency = t.struct({
    city: t.String,
    country: KeyValuePair,
    name: t.String,
    state: KeyValuePair
}, {
    name: 'Agency',
    strict: true
});

export const getDefaultState = () => new Agency({
    city: '',
    country: getKeyValuePairDefaultState(),
    name: '',
    state: getKeyValuePairDefaultState()
});

export default Agency;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/agency.js